module.exports = __webpack_public_path__ + "static/img/pic_2@2x.d0181c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/pic_2@2x.png
// module id = 71mX
// module chunks = 1